// src/services/v1/authService.ts
import apiClient from "@/services/apiClient";
import type { LoginResponse, LoginCredentials, SignUpCredentials, SignUpResponse } from "@/types/auth";

export const authService = {
  /**
   * Email/password login
   */
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await apiClient.post('/v1/auth/sign-in', credentials);
    return response.data;
  },

  /**
   * Email/password register
   */
  async register(credentials: SignUpCredentials): Promise<SignUpResponse> { // TODO: Create Sign Up flow
    const response = await apiClient.post('/v1/auth/sign-up', credentials);
    return response.data;
  },

  /**
   * OAuth login with Google/Facebook/etc
   */
  async loginWithProvider(provider: string, code: string): Promise<LoginResponse> {
    const response = await apiClient.post(`/v1/auth/${provider}/callback`, { code });
    return response.data;
  },

  /**
   * Email/password login
   */
  async refreshToken(): Promise<void> {
    const response = await apiClient.post('/v1/auth/refresh');
    return response.data;
  },

  /**
   * Clear session
   */
  async logout() {
    const response = await apiClient.post("/v1/auth/sign-out");
    return response.data
  },
};
